import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IObjectHaveId {
  id: string
  [key: string]: any
}
interface ISelect {
  listName: string
  selectedItem: IObjectHaveId
}
interface ISelectAll {
  listName: string
  elements: any[]
}

interface IUnSelectAll {
  listName: string
}
interface IInitialState {
  [key: string]: any[]
}
const initialState: IInitialState = {}

export const SelectSlice = createSlice({
  name: 'select',
  initialState,
  reducers: {
    Select: (state, action: PayloadAction<ISelect>) => {
      state[action.payload.listName] = state[action.payload.listName]
        ? [...state[action.payload.listName], action.payload.selectedItem]
        : [action.payload.selectedItem]
    },
    SelectAll: (state, action: PayloadAction<ISelectAll>) => {
      state[action.payload.listName] = action.payload.elements
    },
    Unselect: (state, action: PayloadAction<ISelect>) => {
      const updatedCollection = state[action.payload.listName].filter(
        (item: any) => item.id !== action.payload.selectedItem.id
      )
      state[action.payload.listName] = updatedCollection
    },
    UnselectAll: (state, action: PayloadAction<IUnSelectAll>) => {
      state[action.payload.listName] = []
    },
  },
})
export const { Select, SelectAll, Unselect, UnselectAll } = SelectSlice.actions
export default SelectSlice.reducer
